import { ServiceApi } from '../../utils/auth'

const state = {
    companies: [],
    company: {},
    loading: false,
    error: null,
    points: 0
}

const actions = {
    // LIST COMPANY
    async fetchCompany({ commit }, payload) {
        try {
            commit('companyBegin')
            const data = await ServiceApi.get('/api/get-companies', payload)
            commit('SET_COMPANIES', data)
            commit('companySuccess', true)
            return data
        } catch (error) {
            commit('companyErr', error)
            return error
        }
    },

    // SHOW COMPANY
    async fetchShowCompany({ commit }, id) {
        try {
            commit('companyBegin')
            const res = await ServiceApi.get(`/api/companies/${id}`);
            commit("SET_COMPANY", res.data);
            commit('companySuccess', true)
            return res.data;
        } catch (error) {
            commit('companyErr', error)
            return error
        }
    },

    // DELETE COMPANY
    async deleteCompany({ commit }, id) {
        try {
            commit('companyBegin')
            const res = await ServiceApi.delete(`api/companies/${id}`);
            commit('SET_DELETE_COMPANIES', data)
            commit('companySuccess', true)
            return res;
        } catch (error) {
            commit('companyErr', error)
        }
    },

    async getUsername({ commit }, payload) {
        try {
            const res = await ServiceApi.get(`/api/get-company-username`, payload);
            return res.data.data;
        } catch (error) {
            throw error;
        }
    },

    async submitCompany({ commit }, payload) {
        commit('companyBegin')
        const { id, name, email, phone, address, contact_full_name, username, facebook, instagram, tiktok, twitter, city_id, picture, logo, latitude, longitude, wp_id } = payload;
        const data = new FormData();
        data.append("name", name);
        data.append("email", email);
        data.append("phone", phone);
        data.append("address", address);
        data.append("contact_full_name", contact_full_name);
        data.append("username", username);
        data.append("facebook", facebook);
        data.append("instagram", instagram);
        data.append("tiktok", tiktok);
        data.append("twitter", twitter);
        data.append("city_id", city_id);
        data.append("picture", picture);
        data.append("logo", logo);
        data.append("latitude", latitude);
        data.append("longitude", longitude);
        data.append("wp_id", wp_id);

        try {
            if (!id) {
                const resp = await ServiceApi.post("api/companies", data);
                commit('companySuccess', true)
                return resp.data;
            } else {
                data.append("id", id);
                data.append("_method", "PUT");
                const res = await ServiceApi.post(`api/companies/${id}`, data);
                commit('companySuccess', true)
                return res.data;
            }
        } catch (error) {
            commit('companyErr', error)
            return error
        }
    },

    async getCompanyPoints({ commit }, id) {
        commit('companyBegin')
        try {
            const resp = await ServiceApi.get(`api/get-company-configuration/${id}`);
            commit('SET_POINTS_COMPANY', resp.data)
            commit('companySuccess', true)
            return resp.data;
        } catch (error) {
            commit('companyErr', error)
            return error
        }
    },
    async addCoinsToCompany({ commit }, payload) {
        commit('companyBegin')
        try {
            const resp = await ServiceApi.post("api/add-points-to-a-company", payload);
            commit('companySuccess', true)
            return resp.data;
        } catch (error) {
            commit('companyErr', error)
            return error
        }
    },

    async configurationPayments({ commit }, payload) {
        commit('companyBegin')
        try {
            const resp = await ServiceApi.post("api/payment-configuration", payload);
            commit('companySuccess', true)
            return resp.data;
        } catch (error) {
            commit('companyErr', error)
            return error
        }
    },
}

const getters = {
    getCompany: (state) => state.companies,
    getShowCompany: state => state.company,
    companyLoading: (state) => state.loading,
    getPoints: state => state.points
}

const mutations = {
    SET_COMPANIES(state, payload) {
        state.companies = payload.data.data
    },
    SET_DELETE_COMPANIES(state, payload) {
        state.companies.data = state.companies.data.filter(item => item.id !== payload);
    },
    SET_COMPANY(state, payload) {
        state.company = payload.data
    },
    SET_POINTS_COMPANY(state, payload) {
        state.points = payload.data
    },
    companyBegin(state) {
        state.loading = true
    },
    companySuccess(state) {
        state.loading = false
    },
    companyErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
